<div class="flex flex-col h-full gap-4">
    <div class="flex flex-col gap-4 px-10 pt-10">
        <!-- Info banner -->
        <div class="border border-blue-400 bg-blue-100 rounded-md p-2 text-blue-400 w-full flex flex-col gap-4">
            <div class="flex items-center gap-2">
                <mat-icon svgIcon="heroicons_outline:information-circle" class="text-blue-400!"></mat-icon>
                <span>กรณีต้องการอัปเดตข้อความ ให้กดที่ปุ่มอัพเดทเพื่อบันทึกข้อมูล</span>
                <span class="text-blue-400">สามารถกรอกข้อความได้ในรูปแบบ
                    <a href="https://www.markdownguide.org/basic-syntax" target="_blank"
                        class="hover:text-blue-700 hover:underline transition-colors duration-300">Markdown</a>
                </span>
            </div>
        </div>

        <ng-container *ngIf="itemList">
            <div class="flex flex-row gap-4 w-full" *ngFor="let item of itemList; let i = index">
                <div class="border border-gray-200 rounded-md p-8 w-full flex flex-col gap-4">

                    <!-- Header row -->
                    <div class="flex justify-between items-center">
                        <span class="text-xl font-semibold text-gray-700">{{ item.validateFootnoteTName }}</span>
                        <div class="flex items-center gap-2">
                            <!-- Preview toggle -->
                            <mat-button-toggle-group [(ngModel)]="previewMode[i]" name="mode-{{i}}">
                                <mat-button-toggle value="edit">
                                    <mat-icon>edit</mat-icon> แก้ไข
                                </mat-button-toggle>
                                <mat-button-toggle value="preview">
                                    <mat-icon>visibility</mat-icon> แสดงตัวอย่าง
                                </mat-button-toggle>
                                <mat-button-toggle value="split">
                                    <mat-icon>view_column</mat-icon> แบบแบ่งหน้าจอ
                                </mat-button-toggle>
                            </mat-button-toggle-group>

                            <button mat-raised-button color="accent" (click)="updateItem(item)">
                                <span>อัพเดท</span>
                            </button>
                        </div>
                    </div>

                    <!-- Edit only -->
                    <div *ngIf="previewMode[i] === 'edit'">
                        <mat-form-field class="flex-auto w-full">
                            <textarea matInput [(ngModel)]="item.validateFootnoteRemark" name="remark-{{i}}"
                                rows="8"></textarea>
                        </mat-form-field>
                    </div>

                    <!-- Preview only -->
                    <div *ngIf="previewMode[i] === 'preview'"
                        class="border border-gray-200 rounded-md p-4 min-h-[120px] prose max-w-none"
                        [innerHTML]="item.validateFootnoteRemark | markdown">
                    </div>

                    <!-- Split view -->
                    <div *ngIf="previewMode[i] === 'split'" class="flex gap-4">
                        <div class="w-1/2">
                            <p class="text-xs text-gray-400 mb-1 font-medium uppercase tracking-wide">Editor</p>
                            <mat-form-field class="flex-auto w-full">
                                <textarea matInput [(ngModel)]="item.validateFootnoteRemark" name="remark-split-{{i}}"
                                    rows="8"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="w-1/2">
                            <p class="text-xs text-gray-400 mb-1 font-medium uppercase tracking-wide">Preview</p>
                            <div class="border border-gray-200 rounded-md p-4 min-h-[120px] prose max-w-none"
                                [innerHTML]="item.validateFootnoteRemark | markdown"></div>
                        </div>
                    </div>

                </div>
            </div>
        </ng-container>
    </div>
</div>